;
define("product_list_bulk_actions.tpl", function(){});

